// utils/formFieldUtils.js
import dayjs from "dayjs";

export const parseDefaultValue = (field, value) => {
    if (field.type === "date" && value) {
        const parsed = dayjs(value);
        return parsed.isValid() ? parsed : null;
    }
    if (field.type === "number" && value !== undefined) {
        return Number(value) || "";
    }
    return value ?? null;
};

export const formatSubmitValue = (field, value) => {
    if (field.type === "date" && value) {
        return value.toISOString();
    }
    if (field.type === "number" && value) {
        return Number(value);
    }
    return value;
};
